module.exports = __webpack_public_path__ + "static/facebook-ee038589cf001009842ff6050467550e.png";